import React, { useCallback } from 'react';

import {
  Box,
  Container,
  Grid,
  ImageList,
  ImageListItem,
} from '@material-ui/core';

import { Image } from '../components';
import { useIsMobile, useIsTablet } from '../hooks/useBreakpoints';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBrands, BlockBuilder } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
}));

type Props = BlockBuilder<BlockBrands>;

export const BrandsBlock: React.FC<Props> = ({ block, getImageData }) => {
  const { items } = block;
  const classes = useBlockStyles(useStyles, block);
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();
  const gridCols = isMobile ? 2 : isTablet ? 4 : 5;
  const filteredItems = items.filter(({ image }) => !!image);

  const getImageItem = useCallback(
    (item) => (
      <Image
        getImageData={getImageData}
        src={item.image}
        alt={item.alt}
        options={{
          height: '100%',
        }}
      />
    ),
    [],
  );

  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid
          container
          justifyContent="space-around"
          alignContent="center"
          alignItems="center"
          style={{ textAlign: 'center' }}
          spacing={4}
        >
          <ImageList
            cols={gridCols}
            rowHeight={100}
            style={{
              justifyContent: 'center',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {filteredItems.map((item, idx) => (
              <ImageListItem
                key={`${item.image}_${idx}`}
                style={{ padding: '0.75rem 0' }}
              >
                {item.link ? (
                  <a href={item.link}>{getImageItem(item)}</a>
                ) : (
                  getImageItem(item)
                )}
              </ImageListItem>
            ))}
          </ImageList>
        </Grid>
      </Container>
    </Box>
  );
};
